<!--
  Example usage:

  <TextInput
    id='mytext_input'
    bind:value={block.preview_title}
  />
 -->
 <script>
  let {
    ref = $bindable(),
    id,
    /** Accessible name for inputs whose only visible caption is a placeholder */
    aria_label,
    name,
    /** @type {'text' | 'email' | 'tel' | 'url' | 'search' | 'password'} */
    type = 'text',
    value = $bindable(),
    placeholder,
    class: css_class,
    onkeydown,
    onenter,
    onshiftenter,
    onenter_without_shift,
    onchange,
    oninput,
    onclick,
    onblur,
    onfocus,
    disabled,
    readonly,
    style,
     /**
     * Defines the visual style of the input. Combines surface and color variants.
     * @type {string} - Space-separated combination of the following:
     * Surface: 'outlined' | 'underlined' | 'ghostly'
     * Color: 'canvas' | 'system'
     * @example "brand subtle-outlined"
     */
    variant = 'brand subtle-outlined',
    text_style = 'text-control',
    align = 'stretch',
    multiline = false,
    required = false,
    inputmode = 'text',
    autocomplete = 'off',
    autofocus = false,
    pattern,
    /**
     * Error message to display below the input.
     * @type {string}
     */
    error,
  } = $props();

  function handle_keydown(e) {
    // HACK: we make sure that keydown events don't bubble up to the parent
    // Could this become a problem somewhere?
    e.stopPropagation();
    onkeydown && onkeydown(e);

    // Handle enter key press
    if (e.key === 'Enter') {
      onenter && onenter(e);
    }
    // handle shift enter
    if (e.key === 'Enter' && e.shiftKey) {
      onshiftenter && onshiftenter(e);
    }
    // handle enter without shift
    if (e.key === 'Enter' && !e.shiftKey) {
      onenter_without_shift && onenter_without_shift(e);
    }
  }

  const css_class_derived = $derived(`text-input selected-outline-on-focus ${text_style} ${variant} ${align} ${variant.includes('outlined') ? variant.includes('system') ? 'border-1-system' : 'border-1' : ''} ${css_class}`);
</script>

<!-- style:--char-length={ value && value.toString().length || 1 } -->
{#if multiline}
  <textarea
    bind:this={ref}
    {id}
    {name}
    {type}
    {placeholder}
    class='multi-line {css_class_derived}'
    {style}
    {autocomplete}
    autocorrect="off"
    bind:value
    onkeydown={handle_keydown}
    {onchange}
    {oninput}
    {onclick}
    {onblur}
    {onfocus}
    {disabled}
    {readonly}
    {...(required) ? {required} : {}}
    {inputmode}
    {pattern}
  ></textarea>
{:else}
  <!-- svelte-ignore a11y_autofocus (opt-in per call site: single-purpose screens like code entry) -->
  <input
    bind:this={ref}
    {id}
    aria-label={aria_label}
    {autofocus}
    {name}
    {type}
    {placeholder}
    class={css_class_derived}
    {style}
    {autocomplete}
    autocorrect="off"
    bind:value
    onkeydown={handle_keydown}
    {onchange}
    {oninput}
    {onclick}
    {onblur}
    {onfocus}
    {disabled}
    {readonly}
    {...(required) ? {required} : {}}
    {inputmode}
    {pattern}
  />
{/if}
{#if error}
  <p class='text-control text-error'>{error}</p>
{/if}

<!-- CSS is set in form.css -->